// pages/controleBar/comandas/FiltrarComandasPage.js
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useComanda } from "../../../contexts/controleBar/comandas/ComandaContext";
import "./FiltrarComandasPage.css";

const FiltrarComandasPage = () => {
  const { comandasAtivas = [], fetchComandasAtivas } = useComanda();
  const [filtroCodigo, setFiltroCodigo] = useState("");
  const [filtroCliente, setFiltroCliente] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchComandasAtivas(); // endpoint só de comandas não fechadas
  }, [fetchComandasAtivas]);

  const comandasFiltradas = useMemo(() => {
    const codigoNormalizado = filtroCodigo.trim().toLowerCase();
    const clienteNormalizado = filtroCliente.trim().toLowerCase();
    if (!codigoNormalizado && !clienteNormalizado) return comandasAtivas;

    return comandasAtivas.filter((c) => {
      const codigoEncontrado = !codigoNormalizado ||
        c.codigo?.toString().toLowerCase().includes(codigoNormalizado);
      const clienteEncontrado = !clienteNormalizado ||
        (c.nomeCliente || "").toLowerCase().includes(clienteNormalizado);

      return codigoEncontrado && clienteEncontrado;
    });
  }, [comandasAtivas, filtroCodigo, filtroCliente]);

  const visualizarComanda = (comanda) => {
    navigate(`/mesaControlePage/${comanda.mesaId}`, {
      state: { comandaId: comanda.id },
    });
  };

  return (
    <div className="comandas-page">
      <h1>Comandas Abertas</h1>

      <div className="comandas-filtros">
        <div className="comanda-filtro-campo">
          <label htmlFor="filtro-comanda">Comanda</label>
          <input
            id="filtro-comanda"
            className="comanda-filtro"
            placeholder="Buscar pelo número da comanda..."
            value={filtroCodigo}
            onChange={(e) => setFiltroCodigo(e.target.value)}
          />
        </div>

        <div className="comanda-filtro-campo">
          <label htmlFor="filtro-cliente">Nome do Cliente</label>
          <input
            id="filtro-cliente"
            className="comanda-filtro"
            placeholder="Buscar pelo nome do cliente..."
            value={filtroCliente}
            onChange={(e) => setFiltroCliente(e.target.value)}
          />
        </div>
      </div>

      <div className="comandas-lista">
        {comandasFiltradas.length === 0 && (
          <p className="vazio">Nenhuma comanda encontrada.</p>
        )}

        {comandasFiltradas.map((c) => (
          <div key={c.id} className="comanda-card">
            <div className="linha linha-topo">
              <span className="comanda-codigo">
                <strong>#{c.codigo}</strong>
                {c.nomeCliente && (
                  <span className="comanda-cliente"> {c.nomeCliente}</span>
                )}
              </span>

              <span className="hora">
                {new Date(c.abertura).toLocaleTimeString("pt-BR", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>


            <div className="linha">
              <span>Mesa: {c.mesa?.codigo}</span>
              <span className="valor">
                R$ {c.valorTotal?.toFixed(2) || "0,00"}
              </span>
            </div>

            <button
              className="btn-visualizar"
              onClick={() => visualizarComanda(c)}
            >
              Visualizar
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FiltrarComandasPage;
